import React, { useMemo, useRef, } from "react";


import { Box, Button, Typography } from "@mui/material";
import { useTimerContext } from "./TimerLoader";
import UpdateTimeEntry from "./UpdateTimeEntry";
import { useDispatch } from "react-redux";
import { GetDependencyDataMutation } from "./mutations/GetDependencyDataMutation";


import useConfig from "../../core/useConfig";

import { CheckPermission } from "../../core/roles";
import MatterSuiteRoles from "../../core/roles/MatterSuiteRolesEnum";
import TimerList from "./TimerList";
import { useAppSelector } from "../../store/hooks";
import Spinner from "../../components/Spinner";
import { GetCommunicationMutation } from "./mutations/GetCommunicationMutation";

import { Communication, PositionEnum } from "./types";
import { timerActions } from "../../store/timerSlice";
import { useEmail } from "../../core/MailLoader";
import { LoadingButton } from "@mui/lab";
import { UpdateTimeExpenseEntryMutation } from "./mutations/UpdateTimeExpenseEntryMutation";
import useAlert from "../../core/useAlert";


const NavbarTimer = () => {
  const { isRoleLevelCom, locationId } = useConfig();
  const dispatch = useDispatch();
  const showAlert = useAlert();
  const { pausedTimer, startTimer, loading: timerLoading } = useTimerContext();
  const { mailId, isCompose, mailSubject } = useEmail();
  const { timer, timers: { data: timers }, communication, sendMailLoading, timeExpenseEntry } = useAppSelector(state => state.timer)
  const [localVal, setLocalVal] = React.useState("")
  const isShowNewTimerButton = !Object.keys(timer ?? {}).length && !timers?.length;
  const canAddTimer = CheckPermission(MatterSuiteRoles.timeEntryCreate);
  const drawerRef = useRef<any>(null);
  const refetchCommunication = () => {
    dispatch(
      GetCommunicationMutation([mailId], {
        onSuccess: (response: any) => {
          dispatch(
            timerActions.getSteps({
              step: {
                stepId: PositionEnum.CommunicationCreate,
                title: "Communication Log Created",
                subTitle: "Email log created for the matter",
                component: (callback) => (
                  <LoadingButton loading={sendMailLoading} size="small" variant="contained" color={"primary"} onClick={callback}>
                    Send Mail
                  </LoadingButton>
                ),
                data: { resourceType: 3, resourceId: response?.id!, matterId: response?.matterId },
              },
              position: PositionEnum.CommunicationCreate,
            })
          );
        },
      })
    );
  }
  const handleOnClose = () => {
    setLocalVal("")
    if (drawerRef.current) {
      drawerRef.current(false);
    }
  };

  const handleSave = (communication?: Communication, matterId?: string) => {
    const data = {
      ...timeExpenseEntry,
      resourceType: 3,
      resourceId: communication?.id!,
      matterId: matterId!,
      description: mailSubject
    }
    dispatch(
      UpdateTimeExpenseEntryMutation(
        mailId,
        data,
        {
          onLoading: (loading) => timerActions.getSendMailLoading(loading),
          onError: (error) => showAlert(error, { variant: "error" })
        }
      )
    );
    refetchCommunication()
    handleOnClose()
  };

  const timeEntryAction = useMemo(() => {
    if (pausedTimer?.isPaused && pausedTimer?.id !== localVal) {
      setLocalVal(pausedTimer.id!)
      return (
        <UpdateTimeEntry
          onSave={handleSave}
          onClose={handleOnClose}
          timeEntryId={pausedTimer.id as string}
        />
      );
    }
    return null;
  }, [pausedTimer?.id]);

  React.useEffect(() => {
    dispatch(GetDependencyDataMutation(isRoleLevelCom ? locationId! : ""));
  }, []);
  if (!isCompose) return null
  return canAddTimer ? (
    timerLoading?.allTimersLoading || timerLoading?.currentTimerLoading ? (
      <Spinner />
    ) : (
      <Box>
        {timerLoading?.startLoading || timerLoading?.pauseLoading ? (
          <Spinner />
        ) : (
          isShowNewTimerButton && (
            <Button variant="contained" color="primary" onClick={() => startTimer()}>
              Start Timer
            </Button>
          )
        )}
        {timerLoading?.allTimersLoading || timerLoading?.currentTimerLoading ? (
          <Spinner />
        ) : !Object.entries(communication ?? {}).length && (
          <TimerList />
        )}
        {timeEntryAction}
      </Box>
    )
  ) : (
    <Typography>You do not have permission to create time entry</Typography>
  );
};

export default NavbarTimer;
